import {extent} from 'd3-array';
import {scaleBand, scaleOrdinal, scalePoint} from 'd3-scale';
import {shapes, xMeasureName, yMeasureName} from './';
import Default from '../default/';

function _parCoords() {
  const scale = this.scale();
  const measures = this.measures();
  const munged = this.__execs__.munged;
  const innerSize = this.innerSize();
  
  if (this.isColor()) {
    let colorDomain = Default.ordinalDomain(munged); 
    scale.color = scaleOrdinal().domain(colorDomain).range(this.color());
  }

  scale.x = scalePoint().domain(measures.map(d => d.field))
    .rangeRound([0,innerSize.width]);

  measures.forEach(m => {
    let domain = extent(this.data(), d => d[m.field]);
    let scaleName = yMeasureName(m);
    scale[scaleName] = Default.continousScale(domain).rangeRound([innerSize.height, 0])
    this.setCustomDomain(scaleName, domain);
  });
}

function _matrix() {
  const scale = this.scale();
  const measures = this.measures();
  const innerSize = this.innerSize();
  const field = this.__execs__.field;

  if (this.isColor()) {
    let colorDomain = Default.ordinalDomainFlatten(this.data(), field.region);
    scale.color = scaleOrdinal().domain(colorDomain).range(this.color());
  }
  let regionWidth = Math.min(innerSize.width, innerSize.height)
  scale.region = scaleBand().domain(measures.map(d=> d.field)).rangeRound([0, regionWidth]).padding(this.regionPadding());
  measures.forEach(m => {
    let domain = extent(this.data(), d => d[m.field]);
    let yScaleName = yMeasureName(m);
    scale[yScaleName] = Default.continousScale(domain).rangeRound([scale.region.bandwidth(), 0]);
    this.setCustomDomain(yScaleName, domain);
    let xScaleName = xMeasureName(m);
    scale[xScaleName] = Default.continousScale(domain).rangeRound([0, scale.region.bandwidth()]);
    this.setCustomDomain(xScaleName, domain);
  });
}

function _scale() {
  if (this.shape() === shapes[0]) _parCoords.call(this);
  else _matrix.call(this);
}

export default _scale;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/par-coords/_scale.js